import { render, staticRenderFns } from "./RightClickMenu.vue?vue&type=template&id=739c1b1c&scoped=true"
import script from "./RightClickMenu.vue?vue&type=script&lang=js"
export * from "./RightClickMenu.vue?vue&type=script&lang=js"
import style0 from "./RightClickMenu.vue?vue&type=style&index=0&id=739c1b1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739c1b1c",
  null
  
)

export default component.exports